import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getProjectKeyOrIdFromMatchAndQuery } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import { RESOURCE_TYPE_SERVICEDESK_CONTEXT } from './resourceTypeServicedeskContext.constants.tsx';

type ServiceDeskContextData = {
	portalId: number;
	portalUrl: string;
	customerUrl?: string;
	serviceDeskId: number;
	userRole: string;
	canSeeNewIssueView: boolean;
};

export const serviceDeskContextResource: RouteResource<ServiceDeskContextData> =
	createResource<ServiceDeskContextData>({
		type: RESOURCE_TYPE_SERVICEDESK_CONTEXT,
		getKey: ({ match, query }) => getProjectKeyOrIdFromMatchAndQuery({ match, query }),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-context", jiraSpaEntry: "async-resource-servicedesk-context" */ './getData.tsx'
			),
		maxAge: Infinity,
	});
